import { render, staticRenderFns } from "./GestionPointsLoterie.vue?vue&type=template&id=5b3d9f50&"
import script from "./GestionPointsLoterie.vue?vue&type=script&lang=js&"
export * from "./GestionPointsLoterie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports